import React, { FC } from 'react';
import ChangePasswordForm from '../../containers/ChangePasswordForm';
import PageLoader from '../Atoms/PageLoader';

import { Box } from '@material-ui/core';
interface ChangePasswordProps {
  password: any;
}

const DoneChangePassword: FC = () => {
  return <h2>パスワードを変更しました。</h2>;
};

const ChangePassword: FC<ChangePasswordProps> = ({ password }) => {
  return (
    <Box>
      {(() => {
        if (password.Loaded) {
          return;
        }

        // ローディング中
        return <PageLoader />;
      })()}
      {password.Loaded ? (
        password.result ? (
          <DoneChangePassword key="message" />
        ) : (
          <ChangePasswordForm key="form" />
        )
      ) : null}
    </Box>
  );
};

export default ChangePassword;
